import { GeneralCatalogItem } from 'data-layer-cr/dist/models';
import findFromGeneralCatalog from 'src/functions/findFromGeneralCatalog';

import CarItem from 'src/models/helperTypes/CarItem';
import CarItemFromLicense from 'src/models/Quotation/CarItemFromLicense';
import PricingProfileResponse from 'src/models/responseTypes/PricingProfileResponse';

import { getUseOptionFromUseValue } from './helperFunctions';

export type CarDetailsFormData = {
  carBrand: string;
  carModel: string;
  typeOfMoney: string;
  carLicensePlate: string;
  carCategoryLicensePlate: string;
  carYear: string;
  carValue: string;
  isNewCar?: boolean;
  noLicensePlate: boolean;
  hasInvoice: boolean;
  use: string;
  passengersQty: string;
  fuel: string;
  color: string;
};

export const makeEmptyCarDetailsFormData = (): CarDetailsFormData => ({
  carBrand: '',
  carModel: '',
  typeOfMoney: '',
  carLicensePlate: '',
  carCategoryLicensePlate: '',
  carYear: '',
  carValue: '',
  isNewCar: false,
  noLicensePlate: false,
  hasInvoice: false,
  use: '',
  passengersQty: '',
  fuel: '',
  color: '',
});

export const createInitialValues = (
  car: CarItem,
  currentProfile: PricingProfileResponse,
): CarDetailsFormData => ({
  carBrand: car.brand,
  carModel: car.model.id,
  typeOfMoney: currentProfile.typeOfMoney === '₡' ? 'CRC' : 'USD',
  carLicensePlate: car.licensePlate,
  carCategoryLicensePlate: car.category,
  carYear: car.year > 0 ? car.year.toString() : '',
  carValue: car.value > 0 ? car.value.toString() : '',
  isNewCar: car.isNewCar,
  noLicensePlate: car.noLicensePlate,
  hasInvoice: car.hasBill,
  use: getUseOptionFromUseValue(car.use || 'P'),
  passengersQty: car.passengersQty ? car.passengersQty : '',
  fuel: car.fuel ? car.fuel : '',
  color: car.color ? car.color : '',
});

export const generateNewCar = (
  carItemFromLicense: CarItemFromLicense,
  data: CarDetailsFormData,
  groupID: string | null | undefined,
  models: GeneralCatalogItem[],
  brands: GeneralCatalogItem[],
): CarItem => ({
  cylinder: carItemFromLicense.data.cylinders,
  fuel: carItemFromLicense.data.fuel,
  hasBill: data.hasInvoice,
  passengersQty: data.passengersQty || '5',
  serialChassis: carItemFromLicense.data.vin,
  serialMotor: carItemFromLicense.data.engineSerial,
  treasuryValue: '',
  brand: data.carBrand,
  model: {
    id: data.carModel,
    groupId: groupID,
    name: findFromGeneralCatalog(models, data.carModel),
    brand: findFromGeneralCatalog(brands, data.carBrand),
  },
  year: parseInt(data.carYear, 10),
  value: parseFloat(data.carValue),
  isNewCar: data.isNewCar,
  typeOfMoney: data.typeOfMoney,
  licensePlate: data.carLicensePlate,
  category: data.carCategoryLicensePlate,
  use: data.use === 'COMERCIAL' ? 'C' : 'P',
  color: carItemFromLicense.data.color,
  noLicensePlate: data.noLicensePlate,
});
